module.exports = __webpack_public_path__ + "src/img/index_menu/blue/6.png?748a24c20b4feb91fda30c0d031a6497";


//////////////////
// WEBPACK FOOTER
// ./src/img/index_menu/blue/6.png
// module id = 188
// module chunks = 0